import type { Value } from '@firebase/remote-config'

import {
  TRIA_CLIENT_LANGUAGES,
  TRIA_CLIENT_PACKAGE_LOGO_HEIGHT,
} from './index.h'

export type Remote = typeof defaultValues
export type RemoteKeys = keyof Remote

// filter function for remote config keys
export const byKey = (key: string, _?: unknown) => key.startsWith('tria_')

const defaultValues = {
  tria_isAnalyticsEnabled: false,
  tria_analyticsListenerDomain: 'https://listener-go.norago.tv',
  tria_isRecommendedRowsEnabled: true,
  tria_registrationExternalDomain: '',
  tria_defaultLanguage: 'en',
  tria_isNoraLocalizationEnabled: false,
  tria_packageLogoHeight: JSON.stringify(TRIA_CLIENT_PACKAGE_LOGO_HEIGHT),
  tria_isChromecastEnabled: true,
  tria_shoppingCartUrl: '',
  tria_languages: JSON.stringify(TRIA_CLIENT_LANGUAGES),
  tria_subscriberAccountSettingsUrl: '',
  // Temporary solution for FP-2477
  tria_isSentryEnabled: false,
  tria_sentryIgnoreErrors:
    'videojs;validatedomnesting;chrome-extension;node_modules', // semicolon separated list to be converted to array of regexps//
  tria_isGooglePalEnabled: false,
  tria_isServerSentEventsDisabled: false,
  tria_isServerSentEventsReconnectionEnabled: true,
  tria_playerNpawPluginConfig: '',
  tria_isSendCommonMediaClientData: false,
  tria_remoteConfigRealtimeEnabled: true,
  tria_openTelemetryMetricsCollector: '',
  tria_isSmartlibEnabled: false,
  tria_addRefererForPartnerProductProvider: '', // semicolon separated list to be converted to array of partner product providers
  tria_isPinLockInSettingsEnabled: false,
  tria_guestRegistrationLink: '',
  tria_isTrailerPlaybackOnBackgroundEnabled: false,
  tria_organizationId: 0, // 0 or string considered as empty id value, correct id number required
  tria_isTrackAnalyticsCdnInfoEventEnabled: false,
  tria_isTrackAnalyticsStreamInfoEventEnabled: false,
  tria_analyticsStreamInfoEventIntervalSeconds: 10,
}

export const defaults: Remote = Object.assign(
  Object.create(null),
  defaultValues
)

export const remote = Object.keys(defaults).reduce((acc, key) => {
  acc[key] = key
  return acc
}, Object.create(null)) as { [K in RemoteKeys]: K }

// prettier-ignore
export function asType(key: string, value: Value, deftype = 'string') {
  const type = typeof defaults[key as RemoteKeys]

  // this big ternary is quite readable and understandable in my opinion
  return type === 'boolean' ? value.asBoolean()
       : type === 'number'  ? value.asNumber()
       : type === 'string'  ? value.asString()

       // if there is no such value in defaults -> use default type
       : deftype === 'boolean' ? value.asBoolean()
       : deftype === 'number'  ? value.asNumber()
       : deftype === 'string'  ? value.asString()
                               : value.asString()
}
